import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from 'react-router-dom';
import { CATEGORY } from '../../api/endpoints';
import Api_Instance from '../../api/Api_Instance';
import { FaCarAlt } from "react-icons/fa";

function Bussinesssection() {
  const api = Api_Instance.unAuth();
  const [category, setCategory] = useState([]);
  const cateGoryApi = async () => {
    try {
      const res = await api("GET", CATEGORY.GET_CATEGORY);
      setCategory(res?.data?.data);
    } catch (error) { }
  };

  useEffect(() => {
    cateGoryApi()
  }, [])

  return (
    <div className='my-[80px] w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4'>
      <div className="w-full mx-auto">
        <div className='mb-5'>
        <h3 className="text-start font-bold 2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl xl:mb-5 lg:mb-5 md:mb-5 mb-3 mt-5">
          Business <span className='text-secondaryColor'>Opportunities</span> 
        </h3>
        <hr/>
        </div>
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 mt-3">
        {subcategory?.map((data, index) => (
          <div
            key={index}
            className={`border-b border-solid border-[#dcdbdb] p-3 text-text_color
              ${index % 6 !== 5 ? 'border-r' : ''}`} // Add border-right to all except the last in each row
          >
            <h3 className="font-semibold text-xl mb-2 text-ellipsis overflow-hidden whitespace-nowrap">{data?.name}</h3>
            <ul className="text-sm min-h-[80px]">
              {data?.subcategories?.slice(0,3).map((item, subIndex) => (
                <li key={subIndex} className="text-sm	 font-lg">{item?.name}</li>
              ))}
            </ul>
            <NavLink to="/products/best-bussiness" className="text-xs font-semibold mt-2">
              Read More
              <FontAwesomeIcon icon={faArrowRight} className="ml-1 mt-1 fa-xs" />
            </NavLink>
          </div>
        ))}

        <div className="border-b p-3 col-span-2 border-[#dcdbdb] text-start text-text_color">
          <h3 className="font-lg">Sports, Fitness & Entertainment</h3>
          <ul className="text-sm">
            <li className="text-xs font-normal">Automobile Related</li>
            <li className="text-xs font-normal">Commercial Vehicle</li>
            <li className="text-xs font-normal">Four Wheeler</li>
          </ul>
          <NavLink to="/blogdetails" className="text-xs font-semibold mt-2">
            Read More
            <FontAwesomeIcon icon={faArrowRight} className="ml-1 mt-1 fa-xs" />
          </NavLink>
        </div>
      </div> */}
      </div>
      {/* <div class="slider">
        <div class="slides-track">
          <div class="slide">
            <button className='flex align-center items-center justify-center gap-3 border-1 border border-[#D8DFE2] rounded-[60px] py-[12px] px-[20px] w-[100%]'>
              <FaCarAlt />
              <p className='text-nowrap text-[14px]'>Automotive Franchise</p>
            </button>
          </div>
          <div class="slide">
            <button className='flex align-center items-center border-1 border justify-center gap-3 border-[#D8DFE2] rounded-[60px] py-[12px] px-[20px] w-[100%]'>
              <FaCarAlt />
              <p className='text-nowrap text-[14px]'>Automotive Franchise</p>
            </button>
          </div>
         

        </div>
      </div> */}

      <div class="Businessslider slider !m-[15px]">
        <div class="slides-track">
          {category?.map((data) => (
            <div class="slide">
              <button className='bg-[#FAF8F6] flex align-center items-center justify-center gap-3 border-1 border border-[#D8DFE2] rounded-[60px] py-[12px] px-[20px] w-[100%]'>
              <img src={data?.icon} className="text-[#4A5661] w-[20px]" alt='icon'/>
                <p className='text-nowrap text-[14px]'>{data?.name}</p>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Bussinesssection;
